import SVG from "react-inlinesvg";
import { useEffect, useState } from "react";
import dynamic from "next/dynamic";
const AdSlot300x250 = dynamic(() => import("@/component/Ads/AdSlot300x250"));
const AdSlot728x90 = dynamic(() => import("@/component/Ads/AdSlot728x90"));
const MatchScoreCard = ({ matchData = null, scrolled = false }) => {
  const [currentTab, setCurrentTab] = useState(() => {
    switch (matchData?.currentInning) {
      case "First": return 1;
      case "Second": return 2;
      case "Third": return 3;
      case "Fourth": return 4;
      default: return 1;
    }
  });

  const [batsmen, setBatsmen] = useState([]);
  const [bowlers, setBowlers] = useState([]);
  const [extras, setExtras] = useState(null);
  const [yetToBat, setYetToBat] = useState([]);

  useEffect(() => {
    const inningKey = `inn${currentTab}`;
    const batsmenData = matchData?.[`${inningKey}_batsmen`] || [];
    const bowlersData = matchData?.[`${inningKey}_bowlers`] || [];
    const extrasData = matchData?.[`${inningKey}_extras`] || null;
    const yetToBatData = matchData?.[`${inningKey}_yetToBat`] || [];

    setBatsmen(batsmenData);
    setBowlers(bowlersData);
    setExtras(extrasData);
    setYetToBat(yetToBatData);
  }, [currentTab, matchData]);


  return matchData ? (
    <div className="w-full">
      {/* <h2 className="text-lg font-semibold"></h2> */}
      <div className="w-full overflow-x-auto whitespace-nowrap gap-4 flex md:justify-start   md:gap-2 items-center my-4 ">
        {matchData?.inn1_team && (
          <button
            onClick={() => {
              setCurrentTab(1);
              // setActiveCommTab(1);
            }}
            className={`min-w-fit flex items-center gap-1 py-2 px-2 md:px-4 rounded-lg border border-gray-300 ${currentTab == 1 ? "border-primary bg-primary text-white" : ""
              }`}
          >
            <img
              src={matchData?.firstInning_image || (matchData?.inn1_team == "IND" ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/1126.png" : matchData.inn1_team == "ENG" ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/1121.png" : ` https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/${matchData?.inn1_team.toLowerCase()}1.png`)}
              width={35}
              height={35}
              alt="teama_logo"
            />
            <div className="flex flex-col gap-1 text-sm">
              <span className="flex items-center gap-2">
                <span>{matchData?.inn1_team}</span>
                <span
                  className={`${currentTab == 1 ? "text-white" : ""
                    }rounded-full bg-gray-400 w-1 h-1`}
                ></span>
                <span
                  className={`${currentTab == 1 ? "text-white" : ""
                    } text-gray-500`}
                >
                  {"1st Inn"}
                </span>
              </span>
              <span>{matchData?.inn1_score || "Yet to Bat"}</span>
            </div>
          </button>
        )}
        {matchData?.inn2_team && (
          <button
            onClick={() => {
              setCurrentTab(2);
              // setActiveCommTab(1);
            }}
            className={`min-w-fit flex items-center gap-2 py-2 px-2 md:px-4 rounded-lg border border-gray-300 ${currentTab == 2 ? "border-primary bg-primary text-white" : ""
              }`}
          >
            <img
              src={matchData?.secondInning_image || (matchData?.inn2_team == "IND" ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/1126.png" : matchData.inn2_team == "ENG" ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/1121.png" : ` https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/${matchData?.inn2_team.toLowerCase()}1.png`)}
              width={35}
              height={35}
              alt="teamb_logo"
            />
            <div className="flex flex-col gap-1 text-sm">
              <span className="flex items-center gap-2">
                <span>{matchData?.inn2_team}</span>
                <span
                  className={`${currentTab == 2 ? "text-white" : ""
                    } rounded-full bg-gray-400 w-1 h-1`}
                ></span>
                <span
                  className={`${currentTab == 2 ? "text-white" : ""
                    }text-gray-500`}
                >
                  {"2nd Inn"}
                </span>
              </span>
              <span>{matchData?.inn2_score || "Yet to Bat"}</span>
            </div>
          </button>
        )}
        {matchData?.inn3_team && (
          <button
            onClick={() => {
              setCurrentTab(3);
              // setActiveCommTab(1);
            }}
            className={`min-w-fit flex items-center gap-1 py-2 px-2 md:px-4 rounded-lg border-gray-300 ${currentTab == 3 ? "border-primary bg-primary text-white" : ""
              }`}
          >
            <img
              src={matchData?.inn3_team == "IND" ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/1126.png" : matchData.inn3_team == "ENG" ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/1121.png" : ` https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/${matchData?.inn1_team.toLowerCase()}1.png`}
              width={35}
              height={35}
              alt="teama_logo"
            />
            <div className="flex flex-col gap-1 text-sm">
              <span className="flex items-center gap-2">
                <span>{matchData?.inn3_team}</span>
                <span
                  className={`${currentTab == 3 ? "text-white" : ""
                    }rounded-full bg-gray-400 w-1 h-1`}
                ></span>
                <span
                  className={`${currentTab == 3 ? "text-white" : ""
                    } text-gray-500`}
                >
                  {"2nd Inn"}
                </span>
              </span>
              <span>{matchData?.inn3_score || "Yet to Bat"}</span>
            </div>
          </button>
        )}
        {matchData?.inn4_team && (
          <button
            onClick={() => {
              setCurrentTab(4);
              // setActiveCommTab(1);
            }}
            className={`min-w-fit flex items-center gap-2 py-2 px-2 md:px-4 rounded-lg border border-gray-300 ${currentTab == 4 ? "border-primary bg-primary text-white" : ""
              }`}
          >
            <img
              src={matchData?.inn4_team == "IND" ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/1126.png" : matchData.inn4_team == "ENG" ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/1121.png" : ` https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/${matchData?.inn2_team.toLowerCase()}1.png`}
              width={35}
              height={35}
              alt="teamb_logo"
            />
            <div className="flex flex-col gap-1 text-sm">
              <span className="flex items-center gap-2">
                <span>{matchData?.inn4_team}</span>
                <span
                  className={`${currentTab == 4 ? "text-white" : ""
                    } rounded-full bg-gray-400 w-1 h-1`}
                ></span>
                <span
                  className={`${currentTab == 4 ? "text-white" : ""
                    }text-gray-500`}
                >
                  {"2nd Inn"}
                </span>
              </span>
              <span>{matchData?.inn4_score || "Yet to Bat"}</span>
            </div>
          </button>
        )}
      </div>

      {/* batsmen */}
      {batsmen?.length > 0 && (
        <div className="w-full border border-gray-300 rounded-lg my-4">
          <div className="px-4 py-2 w-full flex items-center gap-2 border-b">
            <h2 className="w-[50%] md:w-[60%] text-gray-500 font-semibold">
              Batters
            </h2>
            <div className="w-[60%] md:w-[40%] text-gray-500 flex items-center gap-4 justify-end">
              <div className="w-[10%]">R</div>
              <div className="w-[10%]">B</div>
              <div className="w-[10%]">4s</div>
              <div className="w-[10%]">6s</div>
              <div className="w-[30%] md:w-[20%]">SR</div>
            </div>
          </div>
          {batsmen?.map((batsman, index) => {
            return (
              <div
                key={index}
                className={`px-4 py-2 w-full ${index != batsman.length - 2 ? "border-b border-gray-300" : ""
                  } flex items-center gap-2 text-sm md:text-md`}
              >
                <div className="w-[50%] md:w-[60%] flex flex-col gap-2">
                  <span className="flex items-center gap-2">
                    <span className="line-clamp-1">{batsman?.batsmanName}</span>
                    {batsman?.striker == "Yes" && (
                      <SVG src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/bat.svg" />
                    )}
                  </span>
                  <span
                    className={`${batsman?.howOut == "not out"
                      ? "text-green-500"
                      : "text-gray-500"
                      } text-xs flex items-center gap-2`}
                  >
                    {batsman?.howOut == "not out" ? "Not Out" : batsman?.howOut}
                  </span>
                </div>
                <div className="w-[60%] md:w-[40%] flex items-center gap-4 justify-end text-md text-gray-600">
                  <div className="w-[10%]">{batsman?.runs || 0}</div>
                  <div className="w-[10%]">{batsman?.ballsFaced || 0}</div>
                  <div className="w-[10%]">{batsman?.fours || 0}</div>
                  <div className="w-[10%]">{batsman?.sixes || 0}</div>
                  <div className="w-[30%] md:w-[20%]">{batsman?.sr || 0}</div>
                </div>
              </div>
            );
          })}
        </div>
      )}
      {scrolled && (
        <div className="my-3">
          <AdSlot300x250
            divId={"div-gpt-ad-1659434785315-0"}
            minWidth="300px"
            minHeight="250px"
          />

          <AdSlot728x90
            divId={"div-gpt-ad-1707804176041-3"}
            minWidth="720px"
            minHeight="90px"
          />
        </div>
      )}
      {/* extras  */}
      {extras && (
        <div className="w-full flex flex-col gap-0 my-4 rounded-lg border border-gray-300">
          <div className="w-full flex items-center gap-2 px-4 py-2 border-b">
            <h2 className="w-[50%] md:w-[70%] text-gray-500 font-semibold">
              Extras
            </h2>
            <div className="w-[50%] md:w-[30%] text-gray-500 flex items-center justify-end gap-2">
              <div className="w-[20%]">B</div>
              <div className="w-[20%]">W</div>
              <div className="w-[20%]">NB</div>
              <div className="w-[20%]">LB</div>
            </div>
          </div>
          <div className="w-full flex items-center gap-2 px-4 py-2">
            <div className="w-[50%] md:w-[70%] text-gray-500 font-semibold">
              {extras?.runs}
            </div>
            <div className="w-[50%] md:w-[30%] text-gray-500 flex items-center justify-end gap-2">
              <div className="w-[20%]">{extras?.b}</div>
              <div className="w-[20%]">{extras?.w}</div>
              <div className="w-[20%]">{extras?.nb}</div>
              <div className="w-[20%]">{extras?.lb}</div>
            </div>
          </div>
        </div>
      )}

      {/* yet to bat */}
      {yetToBat?.length > 0 && (
        <div className="w-full my-4 flex flex-col rounded-lg border border-gray-300">
          <h2 className="font-semibold text-gray-500 border-b px-4 py-2">
            Yet to Bat
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-3 px-4 py-2">
            {yetToBat?.map((batsman) => {
              return (
                <div
                  key={batsman?.batsmanId}
                  className="flex items-center gap-2 p-2"
                >
                  <img
                    src={`https://akm-img-a-in.tosshub.com/sites/live-score/resources-live/images/flag_img_st/players/asia-cup/${batsman?.batsmanId}.jpg` || `https://akm-img-a-in.tosshub.com/sites/sports/ipl/resources_live/images/players_img/ipl_2025/${batsman.batsmanId}.png`}
                    width={35}
                    height={35}
                    loading="lazy"
                    onError={(e) => {
                      e.target.src =
                        "https://akm-img-a-in.tosshub.com/sites/sports/ipl/resources_live/images/players_img/ipl_2025/0.png";
                    }}
                    className="rounded-full"
                    alt={batsman.batsmanName + "logo"}
                  />
                  <span className="text-gray-500">{batsman.batsmanName}</span>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* bowlers  */}
      {bowlers?.length > 0 && (
        <div className="w-full my-4 flex flex-col rounded-lg border border-gray-300">
          <div className="px-4 py-2 w-full flex items-center gap-2 border-b">
            <h2 className="w-[50%] md:w-[60%] text-gray-500 font-semibold">
              Bowlers
            </h2>
            <div className="w-[60%] md:w-[40%] text-gray-500 flex items-center gap-4 justify-end">
              <div className="w-[10%]">O</div>
              <div className="w-[10%]">M</div>
              <div className="w-[10%]">R</div>
              <div className="w-[10%]">W</div>
              <div className="w-[30%] md:w-[20%]">Econ</div>
            </div>
          </div>
          {bowlers?.map((bowler, index) => {
            return (
              <div
                key={index}
                className={`px-4 py-4 w-full ${index != bowler.length - 2 ? "border-b border-gray-300" : ""
                  } flex items-center gap-2 text-sm md:text-md`}
              >
                <div className="w-[50%] md:w-[60%]">
                  <span className="flex items-center gap-1">
                    {bowler?.bowlerName}
                    {bowler?.bowling == "Yes" && (
                      <SVG src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/bowl.svg" />
                    )}
                  </span>
                </div>
                <div className="w-[60%] md:w-[40%] flex items-center gap-4 justify-end text-md text-gray-600">
                  <div className="w-[10%]">{bowler?.overs || 0}</div>
                  <div className="w-[10%]">{bowler?.maidens || 0}</div>
                  <div className="w-[10%]">{bowler?.runsGiven || 0}</div>
                  <div className="w-[10%]">{bowler?.wickets || 0}</div>
                  <div className="w-[30%] md:w-[20%]">{bowler?.econ || 0}</div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  ) : (
    <div className="w-full flex flex-col items-center justify-center text-lg text-gray-500 mt-10 mb-12">
      <SVG src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/NoMatchData.svg" className="w-22 h-122 rounded-full mb-4" />
      मैच जल्दी शुरू होगा लाइव अपडेट्स के लिए बने रहें
    </div>
  );
};

export default MatchScoreCard;
